/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import API from 'api';
import { normalizeEnterprise } from 'api/normalize';
// eslint-disable-next-line no-restricted-imports
import { LOAD_HEADER_SUCCESS, LoadHeaderSuccessAction } from 'modules/loaders';
// eslint-disable-next-line no-restricted-imports
import { getMe } from 'selectors/members';
// eslint-disable-next-line no-restricted-imports
import {
  EnterpriseModel,
  EnterpriseResponse,
  StandardThunkAction,
} from 'types';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from 'util/actions';
// eslint-disable-next-line no-restricted-imports
import { createReducer } from 'util/reducers';

export const FETCH_ENTERPRISES_START = Symbol('models/FETCH_ENTERPRISE_START');
export const FETCH_ENTERPRISES_SUCCESS = Symbol(
  'models/FETCH_ENTERPRISE_SUCCESS',
);
export const FETCH_ENTERPRISES_ERROR = Symbol('models/FETCH_ENTERPRISE_ERROR');

type FetchEnterpriseSuccessAction = Action<
  typeof FETCH_ENTERPRISES_SUCCESS,
  { enterprises: EnterpriseResponse[] }
>;

export interface EnterpriseState {
  isLoading: boolean;
  collection: {
    [idEnterprise: string]: EnterpriseModel;
  };
}

const initialState: EnterpriseState = {
  isLoading: false,
  collection: {},
};

const upsertEnterprise = (
  state: EnterpriseState,
  enterprise: EnterpriseResponse,
) => ({
  ...state,
  collection: {
    ...state.collection,
    [enterprise.id]: {
      ...(state.collection[enterprise.id] || {}),
      ...normalizeEnterprise(enterprise),
    },
  },
});

export default createReducer(initialState, {
  [LOAD_HEADER_SUCCESS](state, { payload }: LoadHeaderSuccessAction) {
    if (!payload.enterprises) {
      return state;
    }

    return payload.enterprises.reduce(
      (result, enterprise) => upsertEnterprise(result, enterprise),
      state,
    );
  },

  [FETCH_ENTERPRISES_START](state) {
    return {
      ...state,
      isLoading: true,
    };
  },

  [FETCH_ENTERPRISES_SUCCESS](
    state,
    { payload }: FetchEnterpriseSuccessAction,
  ) {
    return payload.enterprises.reduce(
      (result, enterprise) => upsertEnterprise(result, enterprise),
      {
        ...state,
        isLoading: false,
      },
    );
  },

  [FETCH_ENTERPRISES_ERROR](state) {
    return {
      ...state,
      isLoading: false,
    };
  },
});

export const fetchMyEnterprises = (): StandardThunkAction => {
  return async (dispatch, getState) => {
    const state = getState();
    const me = getMe(state);
    if (!me) {
      return;
    }

    try {
      const { idEnterprisesAdmin = [] } = me;
      const enterprises = state.models.enterprises.collection;
      const promises = idEnterprisesAdmin.reduce(
        (result: Promise<EnterpriseResponse>[], idEnterprise: string) => {
          if (!enterprises[idEnterprise]) {
            result.push(
              API.client.rest.get<EnterpriseResponse>(
                `enterprises/${idEnterprise}`,
              ),
            );
          }

          return result;
        },
        [] as Promise<EnterpriseResponse>[],
      );

      if (!promises.length) {
        return;
      }

      dispatch(actionCreator(FETCH_ENTERPRISES_START)());

      const responses = await Promise.all(promises);

      dispatch(
        actionCreator(FETCH_ENTERPRISES_SUCCESS)({ enterprises: responses }),
      );
    } catch (err) {
      dispatch(actionCreator(FETCH_ENTERPRISES_ERROR)());
    }
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/state/models/enterprises.ts